jQuery(document).ready(function ($) {
    const jQueryBridget = require('jquery-bridget');
    const Flickity = require('flickity-imagesloaded');
    require('flickity-as-nav-for');
    require('flickity-css');

    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);

    /** Flight Charts **/
    const $charts = $('#flight-charts').flickity({
        "pageDots": false,
        "wrapAround": true,
        "freeScroll": false,
        "imagesLoaded": true
    });

    const $chartControls = $('#flight-chart-controls .chart-control');
    const $chartItems = $('#flight-chart-controls li');

    $charts.on('select.flickity', function () {
        let index = $charts.data('flickity').selectedIndex;

        $chartItems.removeClass('active');
        $chartItems.eq(index).addClass('active');
    });

    $chartControls.on('click', function (event) {
        event.preventDefault();
        $charts.flickity('select', $(this).parent().index());
    });
});
